import './index.scss'
import React from 'react'
import Content from '../../../components/content'

// 我们的团队
const Tabs = (props) => {
  // 切换显示 tab
  function switchTabContent(e) {
    const container = $(e.target).parents('.section-tabs')
    container.find('.tab-content')
      .removeClass('active').end()
      .find(`[data-tab=${$(e.target).data('display')}]`).addClass('active')
    container.find('.tab-navs').find('.active').removeClass('active')
    $(e.target).parents('li').addClass('active')
    e.stopPropagation()
    return false
  }
  //
  return [{
    uid: 'tabs-1',
    html:(
      <div className="section-tabs" style={{paddingBottom: 0}}>
        <div className="container">
          <Content { ...props.title } className="text-center" />
          
          <ul className="list-inline tab-navs">
            {props.list.items.map((item, index) =>
              <li key={index} className={index === 0 ? 'active' : ''}>
                <a href={'#tab'+index}
                   onClick={(e) => switchTabContent(e) }
                   data-display={index}>
                  { item.subtitle ? item.subtitle.content : '' }
                </a>
              </li>
            )}
          </ul>

          <div className="tab-contents-wrapper">
          {props.list.items.map((item, index) =>
            <div data-tab={index}
                 className={"tab-content"+(index === 0 ? ' active' : '')}
                 key={index}>
              <div className="row vertical-align">
                <div className="col-sm-6 col-sm-push-6">
                  <div className="tab-content-des">
                    <Content { ...item.title } />
                    <Content { ...item.description } />
                    <Content { ...item.button } className="btn btn-primary" />
                  </div>
                </div>
                <div className="col-sm-6 col-sm-pull-6">
                  <Content { ...item.media } />
                </div>
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    )
  }]
}

export default Tabs


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/tabs/index.js